import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ApplicationService, ApplicationMode } from '../../../services/application.service';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html'
})
export class RegisterComponent implements OnInit {

  repNumber: number;
  enterOtp = "";
  error = "";
  step = 1;
  otpCode: number;
  password: string;
  confirm: string;
  hide = true;
  strength: string;
  color = "white";
  
  constructor(
    private http: HttpClient,
    private applicationService: ApplicationService,
    public userService: UserService,
    public router: Router
  ) {

  }
  
  ngOnInit() {
    this.applicationService.pageTitle = "Please Sign In";
    this.applicationService.profileText = "LET'S CONNECT!";
    this.userService.accept = false;
  }

  sendOTP() {

    this.error = "";
    this.http.get<any>(this.applicationService.apiServiceUrl + '/User/SendOtp?repNumber=' + this.repNumber + "&type=2")
      .toPromise().then(response => {
        if (response.Result) {
          this.step = 2;
          this.enterOtp = response.Message;
        }
        else {
          this.error = response.Response;
        }
      });

  }

  get showRegister(): boolean {
    if (this.password == this.confirm && this.otpCode && this.strength == "Strong") {
      return true;
    }
    return false;
  }

  register() {

    this.error = "";

    if (!this.repNumber) {
      alert("Please enter your representative number");
      return;
    }

    if (this.password == this.confirm && this.otpCode && this.strength == "Strong") {
      this.http.post<any>(this.applicationService.apiServiceUrl + '/User/Register', { RepNumber: this.repNumber, Otp: this.otpCode, Password: this.password })
        .toPromise().then(response => {
          if (response.Result) {
            this.applicationService.createApplicationLog("Function", "Register", this.repNumber);
            sessionStorage.setItem("localOTP", "true");
            this.userService.login(this.applicationService, this.repNumber.toString(), this.password, false);
          }
          else {
            this.error = response.Response;
          }
        });
    }

  }

  validatePassword() {

    try {
      // Do not show anything when the length of password is zero.
      let length = this.password.length;
      if (length < 8) {
        this.strength = "Enter a strong password with at least 8 characters";
      }
      // Create an array and push all possible values that you want in password
      var matchedCase = new Array();
      matchedCase.push("[$@$!%*#?&]"); // Special Charector
      matchedCase.push("[A-Z]");      // Uppercase Alpabates
      matchedCase.push("[0-9]");      // Numbers
      matchedCase.push("[a-z]");     // Lowercase Alphabates

      // Check the conditions
      var ctr = 0;
      for (var i = 0; i < matchedCase.length; i++) {
        if (new RegExp(matchedCase[i]).test(this.password)) {
          ctr++;
        }
      }
      // Display it
      this.color = "white";
      var strength = "";
      switch (ctr) {
        case 0:
        case 1:
        case 2:
          strength = "Very Weak";
          this.color = "red";
          break;
        case 3:
          strength = "Medium";
          this.color = "orange";
          break;
        case 4:
          if (length < 8) {
            strength = "Medium";
            this.color = "orange";
          }
          else {
            strength = "Strong";
            this.color = "green";
          }
          break;
      }
      this.strength = strength;
    }
    catch { }

    return true;
  }

 

}
